import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14614ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "i-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_input, {
      name: _ctx.name,
      placeholder: _ctx.placeholder,
      type: _ctx.type,
      value: _ctx.modelValue,
      valid: _ctx.valid,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 8, ["name", "placeholder", "type", "value", "valid"])
  ]))
}